// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file bundles/v1/contact.proto (package bundles.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Image, ImageJson } from "./common_pb";
import { file_bundles_v1_common } from "./common_pb";
import type { PostalAddress, PostalAddressJson } from "../../google/type/postal_address_pb";
import { file_google_type_postal_address } from "../../google/type/postal_address_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bundles/v1/contact.proto.
 */
export const file_bundles_v1_contact: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChhidW5kbGVzL3YxL2NvbnRhY3QucHJvdG8SCmJ1bmRsZXMudjEiQgoKU29jaWFsTGluaxIoCgR0eXBlGAEgASgOMhouYnVuZGxlcy52MS5Tb2NpYWxMaW5rVHlwZRIKCgJpZBgCIAEoCSKqAgoLQ29udGFjdERhdGESIAoFcGhvdG8YASABKAsyES5idW5kbGVzLnYxLkltYWdlEhEKCWZ1bGxfbmFtZRgCIAEoCRINCgV0aXRsZRgDIAEoCRISCgpkZXBhcnRtZW50GAQgASgJEg8KB2NvbXBhbnkYBSABKAkSCwoDYmlvGAYgASgJEhMKC3dvcmtfbnVtYmVyGAcgASgJEhUKDW1vYmlsZV9udW1iZXIYCCABKAkSDQoFZW1haWwYCSABKAkSDwoHd2Vic2l0ZRgKIAEoCRIrCgdhZGRyZXNzGAsgASgLMhouZ29vZ2xlLnR5cGUuUG9zdGFsQWRkcmVzcxIsCgxzb2NpYWxfbGlua3MYDCADKAsyFi5idW5kbGVzLnYxLlNvY2lhbExpbmsq2wMKDlNvY2lhbExpbmtUeXBlEiAKHFNPQ0lBTF9MSU5LX1RZUEVfVU5TUEVDSUZJRUQQABIdChlTT0NJQUxfTElOS19UWVBFX0xJTktFRElOEAESFgoSU09DSUFMX0xJTktfVFlQRV9YEAISHgoaU09DSUFMX0xJTktfVFlQRV9JTlNUQUdSQU0QAxIcChhTT0NJQUxfTElOS19UWVBFX1RIUkVBRFMQBBIdChlTT0NJQUxfTElOS19UWVBFX0ZBQ0VCT09LEAUSHQoZU09DSUFMX0xJTktfVFlQRV9TTkFQQ0hBVBAGEhsKF1NPQ0lBTF9MSU5LX1RZUEVfVElLVE9LEAcSHAoYU09DSUFMX0xJTktfVFlQRV9ZT1VUVUJFEAgSHAoYU09DSUFMX0xJTktfVFlQRV9TUE9USUZZEAkSHwobU09DSUFMX0xJTktfVFlQRV9TT1VORENMT1VEEAoSIAocU09DSUFMX0xJTktfVFlQRV9BUFBMRV9NVVNJQxALEh0KGVNPQ0lBTF9MSU5LX1RZUEVfV0hBVFNBUFAQDBIbChdTT0NJQUxfTElOS19UWVBFX1RXSVRDSBANEhwKGFNPQ0lBTF9MSU5LX1RZUEVfRElTQ09SRBAOYgZwcm90bzM",
		[file_bundles_v1_common, file_google_type_postal_address],
	);

/**
 * @generated from message bundles.v1.SocialLink
 */
export type SocialLink = Message<"bundles.v1.SocialLink"> & {
	/**
	 * @generated from field: bundles.v1.SocialLinkType type = 1;
	 */
	type: SocialLinkType;

	/**
	 * @generated from field: string id = 2;
	 */
	id: string;
};

/**
 * @generated from message bundles.v1.SocialLink
 */
export type SocialLinkJson = {
	/**
	 * @generated from field: bundles.v1.SocialLinkType type = 1;
	 */
	type?: SocialLinkTypeJson;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;
};

/**
 * Describes the message bundles.v1.SocialLink.
 * Use `create(SocialLinkSchema)` to create a new message.
 */
export const SocialLinkSchema: GenMessage<SocialLink, { jsonType: SocialLinkJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_contact, 0);

/**
 * @generated from message bundles.v1.ContactData
 */
export type ContactData = Message<"bundles.v1.ContactData"> & {
	/**
	 * @generated from field: bundles.v1.Image photo = 1;
	 */
	photo?: Image | undefined;

	/**
	 * @generated from field: string full_name = 2;
	 */
	fullName: string;

	/**
	 * @generated from field: string title = 3;
	 */
	title: string;

	/**
	 * @generated from field: string department = 4;
	 */
	department: string;

	/**
	 * @generated from field: string company = 5;
	 */
	company: string;

	/**
	 * @generated from field: string bio = 6;
	 */
	bio: string;

	/**
	 * @generated from field: string work_number = 7;
	 */
	workNumber: string;

	/**
	 * @generated from field: string mobile_number = 8;
	 */
	mobileNumber: string;

	/**
	 * @generated from field: string email = 9;
	 */
	email: string;

	/**
	 * @generated from field: string website = 10;
	 */
	website: string;

	/**
	 * @generated from field: google.type.PostalAddress address = 11;
	 */
	address?: PostalAddress | undefined;

	/**
	 * @generated from field: repeated bundles.v1.SocialLink social_links = 12;
	 */
	socialLinks: SocialLink[];
};

/**
 * @generated from message bundles.v1.ContactData
 */
export type ContactDataJson = {
	/**
	 * @generated from field: bundles.v1.Image photo = 1;
	 */
	photo?: ImageJson;

	/**
	 * @generated from field: string full_name = 2;
	 */
	fullName?: string;

	/**
	 * @generated from field: string title = 3;
	 */
	title?: string;

	/**
	 * @generated from field: string department = 4;
	 */
	department?: string;

	/**
	 * @generated from field: string company = 5;
	 */
	company?: string;

	/**
	 * @generated from field: string bio = 6;
	 */
	bio?: string;

	/**
	 * @generated from field: string work_number = 7;
	 */
	workNumber?: string;

	/**
	 * @generated from field: string mobile_number = 8;
	 */
	mobileNumber?: string;

	/**
	 * @generated from field: string email = 9;
	 */
	email?: string;

	/**
	 * @generated from field: string website = 10;
	 */
	website?: string;

	/**
	 * @generated from field: google.type.PostalAddress address = 11;
	 */
	address?: PostalAddressJson;

	/**
	 * @generated from field: repeated bundles.v1.SocialLink social_links = 12;
	 */
	socialLinks?: SocialLinkJson[];
};

/**
 * Describes the message bundles.v1.ContactData.
 * Use `create(ContactDataSchema)` to create a new message.
 */
export const ContactDataSchema: GenMessage<ContactData, { jsonType: ContactDataJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_contact, 1);

/**
 * @generated from enum bundles.v1.SocialLinkType
 */
export enum SocialLinkType {
	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_LINKEDIN = 1;
	 */
	LINKEDIN = 1,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_X = 2;
	 */
	X = 2,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_INSTAGRAM = 3;
	 */
	INSTAGRAM = 3,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_THREADS = 4;
	 */
	THREADS = 4,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_FACEBOOK = 5;
	 */
	FACEBOOK = 5,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_SNAPCHAT = 6;
	 */
	SNAPCHAT = 6,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_TIKTOK = 7;
	 */
	TIKTOK = 7,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_YOUTUBE = 8;
	 */
	YOUTUBE = 8,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_SPOTIFY = 9;
	 */
	SPOTIFY = 9,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_SOUNDCLOUD = 10;
	 */
	SOUNDCLOUD = 10,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_APPLE_MUSIC = 11;
	 */
	APPLE_MUSIC = 11,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_WHATSAPP = 12;
	 */
	WHATSAPP = 12,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_TWITCH = 13;
	 */
	TWITCH = 13,

	/**
	 * @generated from enum value: SOCIAL_LINK_TYPE_DISCORD = 14;
	 */
	DISCORD = 14,
}

/**
 * @generated from enum bundles.v1.SocialLinkType
 */
export type SocialLinkTypeJson =
	| "SOCIAL_LINK_TYPE_UNSPECIFIED"
	| "SOCIAL_LINK_TYPE_LINKEDIN"
	| "SOCIAL_LINK_TYPE_X"
	| "SOCIAL_LINK_TYPE_INSTAGRAM"
	| "SOCIAL_LINK_TYPE_THREADS"
	| "SOCIAL_LINK_TYPE_FACEBOOK"
	| "SOCIAL_LINK_TYPE_SNAPCHAT"
	| "SOCIAL_LINK_TYPE_TIKTOK"
	| "SOCIAL_LINK_TYPE_YOUTUBE"
	| "SOCIAL_LINK_TYPE_SPOTIFY"
	| "SOCIAL_LINK_TYPE_SOUNDCLOUD"
	| "SOCIAL_LINK_TYPE_APPLE_MUSIC"
	| "SOCIAL_LINK_TYPE_WHATSAPP"
	| "SOCIAL_LINK_TYPE_TWITCH"
	| "SOCIAL_LINK_TYPE_DISCORD";

/**
 * Describes the enum bundles.v1.SocialLinkType.
 */
export const SocialLinkTypeSchema: GenEnum<SocialLinkType, SocialLinkTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_contact, 0);
